/* @flow */
import {pick} from 'lodash';
import {ResultsParams} from '../../server/graphql/params';

import type {SearchRequest} from '@homeaway/search-url-parser';
import type {SearchParamsType} from '../reducers/searchParams';

export const canonicalizeSearchRequest = (searchRequest: SearchRequest) => {
    const copy = Object.assign({}, searchRequest);
    // remove nulls and undefineds
    Object.keys(copy).forEach((k) => {
        if (typeof copy[k] === 'undefined' || copy[k] === null) {
            delete copy[k];
        }
    });

    // delete 0s
    ['minPrice', 'maxPrice', 'minBathrooms', 'maxBathrooms'].forEach((k) => {
        if (!copy[k]) {
            delete copy[k];
        }
    });

    // special case for bedrooms since minBedrooms = maxBedrooms = 0 is Studio
    if (copy.minBedrooms !== copy.maxBedrooms) {
        if (copy.minBedrooms === 0) {
            delete copy.minBedrooms;
        }
        if (copy.maxBedrooms === 0) {
            delete copy.maxBedrooms;
        }
    }

    // remove page = 1
    if (copy.page <= 1) {
        delete copy.page;
    }

    // sort the filters
    if (copy.filter) {
        copy.filter.sort();
    }

    return copy;
};

export const isDateless = ({arrival, departure}: SearchParamsType) => {
    return !arrival || !departure;
};

export const isDated = ({arrival, departure}: SearchParamsType) => {
    return arrival && departure;
};

export const prepareParams = (params: SearchParamsType) => {
    const newParams = pick(params, ResultsParams);
    const regionId = newParams.regionId;
    if (regionId && typeof regionId === 'string') {
        newParams.regionId = parseInt(regionId, 10);
    }
    const pinnedPropertyListing = newParams.pinnedPropertyListing;
    if (pinnedPropertyListing && typeof pinnedPropertyListing !== 'string') {
        newParams.pinnedPropertyListing = `${pinnedPropertyListing}`;
    }
    return newParams;
};
